import GuiContext from "config/context/guiContext";
import { useContext, useState } from "react";

export const useSetServerNode = () => {
    const [response, setResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const {
        selected: { selectedServer },
        URL
    } = useContext(GuiContext);

    const setServerNode = async () => {
        setLoading(true);
        if (!selectedServer) return;
        try {
            const res = await fetch(`${URL}/api/monitoring/set-node`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    server_url: selectedServer,
                }),
            });

            if (!res.ok) {
                throw new Error('Failed to set server node!');
            }

            const data = await res.json();
            setResponse(data);
        } catch (err) {
            setError(err.message || 'An error occurred');
        } finally {
            setLoading(false);
        }
    }

    return {
        response,
        loading,
        error,
        setServerNode
    }
}

export const useGetServerStatus = () => {
    const [response, setResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [lastChecked, setLastChecked] = useState('');

    const {
        selected: { selectedServer },
        URL
    } = useContext(GuiContext);
    const getServerStatus = async () => {
        cleanup();
        setLoading(true);
        if (!selectedServer) return;
        try {
            const res = await fetch(`${URL}/api/monitoring/get-node?server_url=${encodeURIComponent(selectedServer)}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!res.ok) {
                throw new Error('Failed to get server status!');
            }

            const data = await res.json();
            setResponse(data);
            setLastChecked(new Date().toLocaleTimeString());
        } catch (err) {
            setError(err.message || 'An error occurred');
        } finally {
            setLoading(false);
        }
    }

    const cleanup = () => {
        setLoading(false);
        setError(null);
    }

    return {
        response,
        loading,
        error,
        getServerStatus,
        lastChecked
    }
}